(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-product-card-price]').forEach(async priceNode=>{try{const root=window.Shopify?.routes?.root||'/';const response=await fetch(`${root}products/${encodeURIComponent(priceNode.dataset.productHandle)}.js`);if(!response.ok)return;const productData=await response.json();const allPrices=productData.variants.map(variant=>variant.price);const availablePrices=productData.variants.filter(variant=>variant.available).map(variant=>variant.price);const prices=availablePrices.length?availablePrices:allPrices;if(!prices.length)return;const minimum=Math.min(...prices);const maximum=Math.max(...allPrices);const formatted=new Intl.NumberFormat(document.documentElement.lang,{style:'currency',currency:priceNode.dataset.currency}).format(minimum/100);priceNode.textContent=minimum===maximum?formatted:priceNode.dataset.priceTemplate.replace('__PRICE__',formatted)}catch(error){priceNode.dataset.priceError='true'}});
  } catch(e) { console.error(e); }
})();

})();
